const getPrintStyles = () => {
    return `
/* Base styles */
      body {
        font-family: Arial, sans-serif;
        line-height: 1.2;
        color: #000;
        background: white;
        padding: 20px;
        margin: 0;
        font-size: 11pt;
      }
      
      /* Company Header */
      .invoice-company-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 15px;
        border-bottom: 2px solid #000;
        padding-bottom: 8px;
        min-height: 90px;
      }

      .company-logo {
        width: 80px;
        height: 60px;
        background-image: url('images/logo.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        flex-shrink: 0;
      }

      @media print {
          .company-logo {
              background-image: url('images/logo.png');
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
          }
      }
      
      .logo-image {
        max-width: 80px;
        max-height: 60px;
      }

      .company-header-info {
        flex-grow: 1;
        text-align: center;
        padding: 0 10px;
      }
      
      .company-header-info h1 {
        margin: 0;
        font-size: 16pt;
        font-weight: bold;
        color: #000;
        letter-spacing: 1px;
      }
      
      .company-header-info h2 {
        margin: 2px 0 8px;
        font-size: 13pt;
        font-weight: bold;
        color: #000;
      }

      .branch-address-wrapper {
        display: flex;
        justify-content: center;
        gap: 30px;
        margin-top: 5px;
        font-size: 8pt;
      }

      .branch-info {
        text-align: left;
        max-width: 200px;
      }

      .branch-info h3 {
        margin: 0 0 3px 0;
        font-size: 9pt;
        font-weight: bold;
        color: #000;
      }

      .branch-info p {
        margin: 1px 0;
        line-height: 1.1;
      }

      .header-spacer {
        width: 80px;
        flex-shrink: 0;
      }
      
      /* Invoice Title */
      .invoice-title {
        text-align: center;
        font-size: 14pt;
        font-weight: bold;
        letter-spacing: 2px;
        margin: 15px 0;
        color: #000;
      }

      /* Invoice Header Section */
      .invoice-header-section {
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
      }

      .sold-to-section {
        width: 60%;
      }

      .invoice-details-section {
        width: 35%;
      }

      .sold-to-box {
        border: 2px solid #000;
        padding: 6px;
        min-height: 60px;
      }

      .sold-to-header {
        font-weight: bold;
        font-size: 10pt;
        margin-bottom: 3px;
        padding: 2px 5px;
        background-color: #f0f0f0;
        border: 1px solid #000;
      }

      .sold-to-content {
        font-size: 9pt;
        line-height: 1.2;
        padding: 3px;
      }

      .invoice-info-table {
        border-collapse: collapse;
        width: 100%;
        border: 2px solid #000;
      }

      .invoice-info-table td {
        border: 1px solid #000;
        padding: 3px 6px;
        font-size: 9pt;
      }

      .invoice-info-table .info-label {
        background-color: #f0f0f0;
        font-weight: bold;
        width: 40%;
      }
      
      /* Invoice Items Table */
      .invoice-table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 20px;
        border: 2px solid #000;
      }
      
      .invoice-table th,
      .invoice-table td {
        border: 1px solid #000;
        padding: 8px;
        text-align: left;
        font-size: 10pt;
      }
      
      .invoice-table th {
        background-color: #f0f0f0;
        font-weight: bold;
        text-align: center;
      }

      .invoice-table .qty-col {
        text-align: center;
        width: 10%;
      }

      .invoice-table .rate-col {
        text-align: right;
        width: 15%;
      }

      .invoice-table .amount-col {
        text-align: right;
        width: 15%;
      }

      .invoice-table .description-col {
        width: 60%;
      }

      /* Serial Number Section */
      .serial-number-section {
        margin: 8px 0;
        border: 2px solid #000;
        padding: 4px;
      }

      .serial-number-section .serial-label {
        font-weight: bold;
        background-color: #f0f0f0;
        padding: 2px 5px;
        border: 1px solid #000;
        display: inline-block;
        margin-bottom: 3px;
        font-size: 9pt;
      }

      /* Total Section */
      .total-section {
        text-align: right;
        margin: 8px 0;
        font-size: 11pt;
        font-weight: bold;
      }

      .total-row {
        border: 2px solid #000;
        padding: 6px 15px;
        background-color: #f0f0f0;
      }
      
      /* Bank Details */
      .bank-details {
        margin: 10px 0;
        border: 2px solid #000;
        padding: 6px;
      }
      
      .bank-details h4 {
        margin: 0 0 5px 0;
        font-size: 10pt;
        font-weight: bold;
        color: #000;
        background-color: #f0f0f0;
        padding: 2px 5px;
        border: 1px solid #000;
        display: inline-block;
      }
      
      .bank-details p {
        margin: 2px 0;
        font-size: 9pt;
        line-height: 1.2;
      }

      /* Signature Section */
      .signature-section {
        margin: 15px 0 10px 0;
        text-align: right;
      }

      .signature-text {
        font-size: 10pt;
        margin-bottom: 25px;
      }

      .signature-line {
        border-bottom: 1px solid #000;
        width: 150px;
        margin: 0 0 3px auto;
      }

      .signature-name {
        font-weight: bold;
        font-size: 9pt;
      }

      .signature-title {
        font-size: 9pt;
        font-weight: bold;
      }
      
      /* Terms & Conditions */
      .invoice-terms {
        margin: 10px 0;
        font-size: 9pt;
        line-height: 1.3;
        border-top: 2px solid #000;
        padding-top: 6px;
      }

      .terms-title {
        font-weight: bold;
        margin-bottom: 3px;
      }

      .terms-content {
        color: #000;
      }
      
      /* Page break handling */
      @page {
        margin: 0.5cm;
      }
      
      .page-break {
        page-break-before: always;
      }
      
      /* Print optimization */
      @media print {
        body {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        
        .invoice-table th,
        .invoice-info-table .info-label,
        .sold-to-header,
        .serial-label,
        .total-row,
        .bank-details h4 {
          background-color: #f0f0f0 !important;
        }
      }
    `;
};

export default getPrintStyles;